module.exports = __webpack_public_path__ + "img/redcompra.552b1932.webp";